import axios from 'axios';
import { loginreq, req, reqTwo } from './axiosFun';

// 登录接口 
export const login = (params) => { return loginreq("POST", "/adminLogin", params) };
// 获取签名信息
export const getMessage = (params) => { return loginreq("POST", "/getMessage", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = (params) => { return req("POST", "/adminLoginOut", params ) };
// 上传轮播
export const loadBanner = (params) => { return reqTwo("POST", "/exImg", params) };
// 上传公告
export const loadNote = (params) => { return reqTwo("POST", "/exNote", params) };
// 用户列表
export const userDataList = (params) => { return reqTwo("POST", "/getUser", params) };


// 代理模式设置 
export const setVIP2Data = (params) => { return req("POST", "/getVIP2", params) };
// 系统设置
export const adminSet = (params) => { return req("POST", "/getSet", params) };
// 修改系统设置
export const adminChangeSet = (params) => { return req("POST", "/exSet", params) };
// 修改密码
export const adminUserSet = (params) => { return req("POST", "/exUserInfo", params) };
// 获得签到奖励
export const userGiveSet = (params) => { return req("POST", "/exUserGive", params) };
// 修改用户资产
export const exAdminUserAmount = (params) => { return req("POST", "/exUserAmount", params) };
// 商品列表
export const getGoodsList = (params) => { return req("POST", "/getGoodList2", params) };
// 商家列表
export const getShopCard = (params) => { return reqTwo("POST", "/getShopCard", params) };
// 商家审核
export const checkShopCard = (params) => { return reqTwo("POST", "/checkShopCard", params) };
// 店铺列表
export const getAllShop = (params) => { return reqTwo("POST", "/getAllShop", params) };
// 店铺操作
export const exShop = (params) => { return reqTwo("POST", "/exShop", params) };
// 商品分类列表
export const getGoodsClassList = (params) => { return reqTwo("POST", "/getList2", params) };
// 新增商品分类列表
export const addGoodsClassList = (params) => { return reqTwo("POST", "/exGoodType", params) };
// 上传商品
export const unloadAddGoods = (params) => { return reqTwo("POST", "/exGood", params) };
// 订单列表
export const OrderList = (params) => { return req("POST", "/getOrderList", params) };
// 更新物流
export const exOrderSet = (params) => { return req("POST", "/exOrder", params) };
// 上传商品

export const adminOnloadImg = (params) => { return reqTwo("POST", "/adminimg", params) };
// 修改用户层级
export const adminEatCengImg = (params) => { return req("POST", "/exUserEat", params) };
// 修改用户代理等级
export const adminEatLeveImg = (params) => { return req("POST", "/exUserAgent", params) };
/**
 * 用户管理 
 **/
// 获取轮播列表
export const userList = (params) => { return reqTwo("POST", "/getImg2", params) };
// 获取公告列表
export const userNoteList = (params) => { return reqTwo("POST", "/getNote2", params) };
// 用户管理-保存（添加编辑）
export const userSave = (params) => { return req("post", "/api/User/save", params) };
// 用户管理-重置密码
export const userPwd = (params) => { return req("post", "/api/User/pwd", params) };
// 用户管理-修改状态
export const userLock = (params) => { return axios.get("/api/User/lock?userId=" + params.userId + "&lock=" + params.lock + "&token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限
export const UserDeptTree = (params) => { return axios.get("/api/UserDept/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-数据权限保存
export const UserDeptSave = (params) => { return req("post", "/api/UserDept/save", params) };
// 用户管理-获取部门设置
export const UserDeptdeptTree = (params) => { return axios.get("/api/UserDept/deptTree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 用户管理-保存部门设置
export const UserChangeDept = (params) => { return req("post", "/api/User/change/dept", params) };
// 用户管理-用户下线
export const userExpireToken = (params) => { return req("get", "/api/User/expireToken/" + params, {}) };
// 用户管理-刷新缓存
export const userFlashCache = (params) => { return req("get", "/api/User/flashCache/" + params, {}) };

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => { return req("post", "/api/Module/list") };
// 菜单管理-根据菜单获取数据
export const ModuleGet = (params) => { return axios.get("/api/Module/get/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = (params) => { return req("post", "/api/Module/nodes", params) };
// 菜单管理-修改菜单
export const ModuleSave = (params) => { return req("post", "/api/Module/save", params) };
// 菜单管理-删除菜单
export const ModuleDelete = (params) => { return axios.delete("/api/Module/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 角色管理 
 **/
// 角色管理-获取角色列表
export const roleList = (params) => { return reqTwo("POST", "/getAdmin", params) };
// 角色管理-添加
export const roleSave = (params) => { return reqTwo("POST", "/exAdmin", params) };
// 角色管理-删除角色
export const roleDelete = (params) => { return axios.delete("/api/Role/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 角色管理-菜单权限（获取）
export const RoleRightTree = (params) => { return axios.get("/api/RoleRight/tree/" + params + "?token=" + localStorage.getItem('logintoken')) };
// 角色管理-菜单权限（保存）
export const RoleRightSave = (params) => { return req("post", "/api/RoleRight/save", params) };

/**
 * 公司管理 
 **/
// 获取IDO申请信息
export const deptList = (params) => { return req("get", "/api/admin/eggshell/getEggshellSubmitApplications", params) };
// 获取合伙人申请信息
export const partnerList = (params) => { return req("get", "/api/admin/eggshell/getWhitelistApprovals", params) };
// 获取IDO抢购信息
export const IDOuPList = (params) => { return req("get", "/api/admin/eggshell/getWhitelistAuthorizations", params) };
// IDO抢购活动按钮
export const IDOuPBtn = (params) => { return req("post", "/api/admin/eggshell/whiteApplyButton", params) };
// 公司管理-保存（添加编辑）
export const deptSave = (params) => { return req("post", "/api/Dept/save", params) };
// 公司管理-删除公司
export const deptDelete = (params) => { return axios.get("/api/Dept/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 系统环境变量 
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = (params) => { return req("post", "/api/Variable/list", params) };
// 系统环境变量-保存（添加编辑）
export const variableSave = (params) => { return req("post", "/api/Variable/save", params) };
// 系统环境变量-删除系统环境变量
export const variableDelete = (params) => { return axios.delete("/api/Variable/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

/**
 * 权限管理 
 **/
// 权限管理-获取权限列表
export const permissionList = (params) => { return req("post", "/api/Permission/list", params) };
// 权限管理-保存权限
export const ermissionSave = (params) => { return req("post", "/api/Permission/save", params) };
// 权限管理-删除权限
export const ermissionDelete = (params) => { return axios.delete("/api/Permission/delete?ids=" + params + "&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-获取权限
export const roleDropDown = () => { return axios.get("/api/Role/dropDown/all?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 权限管理-配置权限
export const RolePermission = (params) => { return req("post", "/api/RolePermission/save", params) };


// WEBPACK FOOTER //
// ./src/api/userMG.js